import { Component } from "@angular/core";
import { LoadingController, ToastController } from "@ionic/angular";
import { BaseComponent } from "../../base.component";
import { Router } from "@angular/router";
import { VendasService } from "src/app/shared/service/vendas/vendas.service";
import { Vendas } from "src/app/shared/model/vendas/vendas.model";
import { clearStorage, getAccountId, getToken } from "../../service/base.service";
import { DatePipe } from "@angular/common";
import { environment } from "src/environments/environment";

@Component({
  selector: 'cmp-painel-vendas',
  templateUrl: './painel-vendas.component.html',
  styleUrls: [
    './painel-vendas.component.scss',
    `../../../../themes/xpory/css/component/vendas/painel-vendas.component.scss`,
    `../../../../themes/xpory-futebol/css/component/vendas/painel-vendas.component.scss`,
    `../../../../themes/fcj-barter/css/component/vendas/painel-vendas.component.scss`,
  ]
})
export class PainelVendasComponent extends BaseComponent {
  theme = environment.theme_name;
  vendas: Vendas[] = [];
  inicio: Date;
  fim: Date;
  dateShowInicio: boolean;
  dateShowFim: boolean;

  count: number = 0;
  offset: number;
  max: number;

  constructor(
    public router: Router,
    public toastController: ToastController, 
    public loadingController: LoadingController,
    private datePipe: DatePipe,
    private service: VendasService){
    super(router, toastController, loadingController);
  }

  ngOnInit(): void {
    this.offset = 0;
    this.max = 12;

    this.carregaSaldo();
  }

  carregaSaldo(){
    this.offset = 0;
    this.max = 12;
    this.vendas = [];
    var token = getToken();
    var accountId = getAccountId();
    if(this.inicio && this.fim){   
      var inicio = this.datePipe.transform(this.inicio, 'MM/dd/yyyy')!;
      var fim = this.datePipe.transform(this.fim, 'MM/dd/yyyy')!;

      this.service.listarData(token, accountId, inicio, fim, this.offset, this.max).then((resultado) =>{
        this.count = resultado.listFullSize;
        this.vendas = resultado.mySales as Vendas[];
      }).catch((ex) =>{
        
      });
    }else{
      this.service.listar(token, accountId, this.offset, this.max).then((resultado) =>{
        this.count = resultado.listFullSize;
        this.vendas = resultado.mySales as Vendas[];
      }).catch((ex) =>{
        
      });
    }
  }

  loadData(event){
    if(this.vendas.length < this.offset + this.max)
      return;

    this.offset = this.offset + this.max;
    var token = getToken();
    var accountId = getAccountId();

    if(this.inicio && this.fim){   
      var inicio = this.datePipe.transform(this.inicio, 'MM/dd/yyyy')!;
      var fim = this.datePipe.transform(this.fim, 'MM/dd/yyyy')!;

      this.service.listarData(token, accountId, inicio, fim, this.offset, this.max).then((resultado) =>{
        if(event.target){
          event.target.complete();
        }

        if(resultado){
          if(!resultado.msg){
            var vendas = resultado.mySales;
            this.vendas = this.vendas.concat(vendas);
          }
        }
      });
    }
    else {
      this.service.listar(token, accountId, this.offset, this.max).then((resultado) =>{
        if(event.target){
          event.target.complete();
        }

        if(resultado){
          if(!resultado.msg){
            var vendas = resultado.mySales;
            this.vendas = this.vendas.concat(vendas);
          }
        }
      });
    }
  }

  onSelectInicio(inicio: Date){
    this.inicio = inicio;
    this.carregaSaldo();
  }

  onSelectFim(fim: Date){
    this.fim = fim;
    this.carregaSaldo();
  }
}